import type { AppUser } from '@/interfaces/service/appuser.interface';

export const setUserInfoInClient = (userInfo: AppUser) => {
  if (userInfo) {
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }
};

/**
 * 로그인 상태확인
 * */
export const getUserInfo = (): AppUser | undefined => {
  if (typeof window === 'undefined') return;

  try {
    const infoInLocal = localStorage.getItem('userInfo');
    return infoInLocal ? JSON.parse(infoInLocal) : undefined;
  } catch (e) {
    console.error('유저 정보 파싱 실패:', e);
    return undefined;
  }
};

export const clearUserInfo = () => {
  localStorage.removeItem('userInfo');
};
